export interface LiveAvailability {
  withinOfficeHours: boolean;
  eligibleAgentAvailable: boolean;
  reason: string;
  timezone: string;
  officeHoursText: string;
  nextOpeningUtc: string | null;
  message: string;
}
export const availabilityNotice = (a: LiveAvailability) =>
  `${a.message} Office hours: ${a.officeHoursText} (${a.timezone}).`;
